//----------------------------------------------------------------------------------------------------------------------
// Metadata Utilities
//----------------------------------------------------------------------------------------------------------------------

/**
 * Collect properties with a common prefix into a single object.
 * Useful for gathering related properties from node metadata.
 *
 * For example, given metadata with:
 * - sound_volume: 0.5
 * - sound_loop: true
 * - sound_spatial: false
 *
 * Calling collectPrefixedProperties(metadata, 'sound') returns:
 * { volume: 0.5, loop: true, spatial: false }
 *
 * @param metadata - The node metadata to search
 * @param prefix - The prefix to match (without trailing underscore)
 * @returns Object with sub-properties (prefix and underscore removed from keys)
 */
export function collectPrefixedProperties(
    metadata : Record<string, unknown>,
    prefix : string
) : Record<string, unknown>
{
    const result : Record<string, unknown> = {};
    const prefixWithUnderscore = `${ prefix }_`;

    for(const [ key, value ] of Object.entries(metadata))
    {
        if(key.startsWith(prefixWithUnderscore))
        {
            const subKey = key.slice(prefixWithUnderscore.length);
            result[subKey] = value;
        }
    }

    return result;
}

//----------------------------------------------------------------------------------------------------------------------
